export default "__VITE_ASSET__f1582355__"